<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="epi1"> </p>
<p class="ep-bot">M.I.C.E., which stands for Money, Ideology, Compromise, and Ego.</p>
<p class="epc"><span class="epub-i">An old CIA acronym for why spies defect.</span></p>
<p class="linespace"> </p>
<p class="ep-bot">When the sheath is broken, you cannot hide the sword.</p>
<p class="epc"><span class="epub-i">An old Russian proverb.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epi1.vue?2803cc10